import React from 'react'
import {ModalBase} from '../ModalBase'
import './modal-error.css'
import Warning from '../../../media/felsv/WarningError.svg'
import {useDispatch} from 'react-redux'
import {generalCloseModalSuscripcion} from '../../../actions/general.actions'
import {useHistory} from 'react-router'
import {KEYS} from '../../../constants/keysStorage'

const ModalErrorSuscripcion = () => {
  const rol = localStorage.getItem(KEYS.ROL)
  const dispatch = useDispatch()
  const history = useHistory()

  const close = () => {
    history.push(rol === '2' ? '/suscripcion/info' : '/home')
    dispatch(generalCloseModalSuscripcion())
  }

  return (
    <ModalBase Styles={{minWidth: '25%', maxWidth: '550px', backgroundColor: '#f1f1f1'}}>
      <div className='modal-error-buttons-fixed-top'>
        <div className='w-layout-hflex '>
          <h3 className='modal-error-title'>
            <img src={Warning} alt='error' />
            &nbsp;&nbsp;&nbsp;Error
          </h3>
        </div>
        <div className='form-separator'></div>
      </div>
      <div className='modal-error-content'>
        <div className='modal-error-message'>
          {rol === '2'
            ? 'Su plan ha alcanzado el límite máximo de facturas emitidas. Por favor renueve su plan.'
            : 'El plan ha alcanzado el límite máximo de facturas emitidas.'}
        </div>
      </div>
      <div className='modal-error-buttons-fixed-bottom'>
        <div className='w-layout-hflex button-actions'>
          <button className='m button w-inline-block' onClick={close}>
            <div>{rol === '2' ? 'Ir a suscripción' : 'Aceptar'}</div>
          </button>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalErrorSuscripcion
